/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import Image from '../../../helpers/Image/Image'
import { agnostifyUrl } from '../../../helpers/utils'
import * as Styled from './M008.styles'

/**
 * - M008 is a component which contains signposts to sub-categories.
 * - It can be placed in a row taking the full width of the row, or it can take 2 columns, leaving a slot for a C004
 */
const M008 = ({ backgroundImageUrl, linkTarget, links, altText, onLinkClick, textColor }) => {
  const svgChevron = () => <Styled.Chevron data-test='m008-chevron' dir='right' textColor={textColor} />

  return (
    <Styled.Wrapper data-test='m008-container' stack='xs' row='sm' gutterValue={0}>
      <Styled.ImageWrapper data-test='m008-image-wrapper' sm={4}>
        {backgroundImageUrl && <Image src={backgroundImageUrl} alt={altText} smart />}
      </Styled.ImageWrapper>
      <Styled.ListContainer data-test='m008-text-container' sm={8} smGutterValue={1} gutterSize='15px'>
        <Styled.LinksContainer data-test='m008-links-container' row='xs' gutterValue={0} forwardedAs='ul'>
          {links.map((link, index) => (
            <li className='xs-6' key={index}>
              <Styled.Link
                data-test={`m008-link-${index}`}
                href={agnostifyUrl(link.linkUrl)}
                target={linkTarget}
                textColor={textColor}
                title={link.linkTitle}
                onClick={(event) => onLinkClick(event, agnostifyUrl(link.linkUrl))}
              >
                {link.name}
                {svgChevron()}
              </Styled.Link>
            </li>
          ))}
        </Styled.LinksContainer>
      </Styled.ListContainer>
    </Styled.Wrapper>
  )
}

M008.propTypes = {
  /** Written copy that describes the Image */
  altText: PropTypes.string,
  /** Optional background image url */
  backgroundImageUrl: PropTypes.string,
  /** Array of items to be shown in the component */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      /** CTA item name */
      linkName: PropTypes.string.isRequired,
      /** CTA item URL */
      linkUrl: PropTypes.string.isRequired,
      /** CTA item title */
      linkTitle: PropTypes.string.isRequired
    })
  ),
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget: PropTypes.oneOf(['', '_blank', '_self']),
  /** Colour of the text, black by default */
  textColor: PropTypes.string
}

M008.defaultProps = {
  altText: '',
  backgroundImageUrl: '',
  links: [],
  textColor: 'black'
}

export default M008
